import { makeAutoObservable, runInAction } from 'mobx'
import i from '../../../translations/i'
import { getUnits } from '../../../helpers/project.controller'
import { openApi } from '../../../helpers/request'
import { notification } from "antd";

class unitController {

    list = []
    listLoadedKey = null
    listLoadingKey = null

    element = {}
    pagination = {
        total: 0,
        limit: 10,
        page: 1,
        offset: 0
    }

    constructor() {
        makeAutoObservable(this)
    }

    get(elementID = 0, all = false, force = false) {
        if(elementID > 0) {
            openApi('get', `/unit/${elementID}`)
                .then(result => {
                    runInAction(() => {
                        this.element = result.data
                    })
                })
        } else {
            const key = all ? 'all' : `${this.pagination.limit}:${this.pagination.page}`

            if (!force && (this.listLoadedKey === key || this.listLoadingKey === key)) return

            this.listLoadingKey = key

            openApi('get', all ? `/unit?limit=1000&page=1` : `/unit?limit=${this.pagination.limit}&page=${this.pagination.page}`)
                .then(result => {
                    this.list = result.data ?? []
                    this.pagination.total = result.total
                    this.listLoadedKey = key
                    getUnits()
                })
                .finally(() => {
                    this.listLoadingKey = null
                })
        }
    }

    set(name, value) {
        this.element[name] = value
    }

    setPage(page) {
        this.pagination.page = page
        this.get()
    }

    save(e) {
        e.preventDefault()

        let facts = new FormData()
        facts.append('description', this.element.description || "")
        facts.append('name', this.element.name || "")
        facts.append('step', this.element.step || 1)

        openApi('post', this.element.id ? `/unit/${this.element.id}` : '/unit', facts)
            .then(result => {
                console.log(result)
                window.location.href = '/shop/units'
                return false
            })
            .catch(error => {
                console.log(error.response)
                notification.error({
                    message: i.t('def:error.error'),
                    description: error.response?.data?.data?.message
                })
            })
    }

    remove(elementID) {
        if (window.confirm(i.t('def:confirms.delete'))) {

            openApi('delete', `/unit/${elementID}`)
                .then(_ => {
                    console.log(_)
                    this.get(0, false, true)
                })
                .catch(error => {
                    console.log(error.response)
                    notification.error({
                        message: i.t('def:error.error'),
                        description: error.response.data.message
                    });
                })
        }
    }
}

export default new unitController()